import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { UserNotification } from '../modal';

export default function reducer(state: UserNotification = new UserNotification(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.USER_NOTIFICATION_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.USER_NOTIFICATION_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.USER_NOTIFICATION_LIST_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
